import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ae56557e4e2660eb65e0be55fc0bb3709b from "./generated-d7caf5df-1bf4-4066-9896-2644a4d82c10.json";

import aac5b4601e1f636502873d422aab4e6b9b from "./generated-102b7f58-7eae-4cc5-b54d-43d6614377ea.json";

import abc44cbe8c01f1fbc0c314a1b1eb1d478b from "./generated-1de0f072-8dcf-4916-9245-74394d50435f.json";

import a5805ee45c5a14a9897abab13c104154eb from "./generated-6edd45dc-49e3-4a75-8466-1ad2a8cd0050.json";

import a60c0c17bc4c295890b7a407178d611b7b from "./generated-ba95d881-eaf4-4939-851d-8cb93222dbe0.json";

import a6c6f9abc2f277f722d9fa5514a826f59b from "./generated-d9b37337-cc7a-41ec-9c51-9300138b0289.json";

import a976411539c258f64cdf61ff8c1ba257bb from "./generated-dd6603e4-dfed-4873-9594-85268de63d62.json";

import ab4b49d3e8cfbad2673e5fdb58dd7fcb3b from "./generated-d846b85d-82c5-4432-9161-cd0bc8f834de.json";

import ae801ff665c9622fb132476680ffef62cb from "./generated-66e6683a-afd9-4abb-8400-f41c098adcd0.json";

import afed2d1531b3f970e8a72ead2592bdd94b from "./generated-55453045-a030-444e-9f44-807f31a4ed2b.json";

import a6cace25bb34d765ae8f5013f3d05c330b from "./generated-2dbb65c0-6c31-4ac5-94bb-e3a62d35e6eb.json";

import ac9039c82a2a31b3ba34b0e9edce1cb56b from "./generated-64a4b92b-e925-4ca2-b31e-096d590f6e87.json";

import a7ec4a25cd3565939681cec20d16fa0e7b from "./generated-ace582ec-eba2-4fc5-893d-125b783c18aa.json";

import a4c1e0bc2e060f22c7a161e4d44fdefc7b from "./generated-68ebfcd8-1397-4111-86fd-04d1b5c5a615.json";

import a0113f219d8273ae492e1ed36829dbbb9b from "./generated-137a5d69-d2cd-426c-a117-4084052542bf.json";

import a69734b2d580b7f6699b0ee8cb5d45c2fb from "./generated-76d922ed-aa2f-4e75-ac22-236f3840e8a5.json";

import a0f28cf9b666dc4c869998b23111e079fb from "./generated-c8a0e13f-5175-4e41-9432-da4ea25c7d31.json";

import ad7d18fefc068b07a7bfdc03b908663b7b from "./generated-02dd8f39-a8dc-447a-b902-c75de2c65706.json";

import aa9b20c4198eb1bac87f71119177e9365b from "./generated-543e5a89-553e-44ec-8e44-1270ceb80cfd.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ae56557e4e2660eb65e0be55fc0bb3709b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aac5b4601e1f636502873d422aab4e6b9b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(abc44cbe8c01f1fbc0c314a1b1eb1d478b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a5805ee45c5a14a9897abab13c104154eb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a60c0c17bc4c295890b7a407178d611b7b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a6c6f9abc2f277f722d9fa5514a826f59b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a976411539c258f64cdf61ff8c1ba257bb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab4b49d3e8cfbad2673e5fdb58dd7fcb3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ae801ff665c9622fb132476680ffef62cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(afed2d1531b3f970e8a72ead2592bdd94b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6cace25bb34d765ae8f5013f3d05c330b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ac9039c82a2a31b3ba34b0e9edce1cb56b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a7ec4a25cd3565939681cec20d16fa0e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a4c1e0bc2e060f22c7a161e4d44fdefc7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a0113f219d8273ae492e1ed36829dbbb9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a69734b2d580b7f6699b0ee8cb5d45c2fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a0f28cf9b666dc4c869998b23111e079fb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ad7d18fefc068b07a7bfdc03b908663b7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aa9b20c4198eb1bac87f71119177e9365b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a0f28cf9b666dc4c869998b23111e079fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */